var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8496 14.3164V21.0937H27.2678C26.8542 23.2732 25.6131 25.1188 23.7518 26.3597L29.4313 30.7665C32.7404 27.7121 34.6495 23.2257 34.6495 17.8961C34.6495 16.6552 34.5382 15.4619 34.3313 14.3166L17.8496 14.3164Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04315 20.832L6.7622 21.8126L2.22803 25.3443C5.10757 31.0557 11.0094 35.0012 17.8503 35.0012C22.5752 35.0012 26.5365 33.4421 29.432 30.7694L23.7525 26.3626C22.1934 27.4126 20.2047 28.049 17.8503 28.049C13.3003 28.049 9.4345 24.9785 8.0503 20.8421L8.04315 20.832Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22772 9.65625C1.03461 12.0107 0.350586 14.6676 0.350586 17.4993C0.350586 20.3311 1.03461 22.988 2.22772 25.3424C2.22772 25.3582 8.05056 20.8242 8.05056 20.8242C7.70056 19.7742 7.49368 18.6607 7.49368 17.4992C7.49368 16.3376 7.70056 15.2241 8.05056 14.1741L2.22772 9.65625Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8506 6.96819C20.4279 6.96819 22.7188 7.85907 24.5484 9.57728L29.5597 4.56597C26.521 1.7342 22.5757 0 17.8506 0C11.0098 0 5.10757 3.92954 2.22803 9.65684L8.05068 14.175C9.43469 10.0386 13.3007 6.96819 17.8506 6.96819Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e003754a1cbf8101d6a9eda4fde1cf9d.svg";
export { ForwardRef as ReactComponent };